import WorkerPaymentsHistory from "../features/download-payment/components/worker-payments-history";


export default function WorkerPaymentsView() {
  return <WorkerPaymentsHistory />;
}